export const COPY = {
    STEPWISE_RESULT_NOT_FOUND_REGEX: /(Result not found, review _stepsTaken to see what happened\.)\s+(\[{.*}])/g,
    CHAT_DELETED_MESSAGE: (chatName?: string) =>
        `${
            chatName ? `{${chatName}} ` : '이'
        } 채팅방을 누군가 삭제했어요. 새로고침하면 더이상 이 채팅방에 접근 할 수 없어요.`,
    REFRESH_APP_ADVISORY: '상단 새로고침 버튼을 눌러주세요.',
};
